import { service } from '@ember/service';
import RESTAdapter from '@ember-data/adapter/rest';
import type { AdapterPayload } from '@ember-data/legacy-compat';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import type { HTTPMethod } from '@warp-drive/core-types/request';
import { pluralize } from 'frontend-utils/utils/ember-data';
import type AjaxService from 'lumen/services/ajax';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';

export default class ParityStrategyIssueAdapter extends RESTAdapter {
  @service('ajax') declare ajaxService: AjaxService;

  host = '';
  namespace = APIGATEWAY;

  constructor(...args: ConstructorParameters<typeof RESTAdapter>) {
    super(...args);

    this.host = this.ajaxService.host;
  }

  // Copied from ApplicationAdapter
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  ajax(url: string, type: HTTPMethod, options: JQueryAjaxSettings = {}) {
    return this.ajaxService.request<AdapterPayload>(
      url,
      // @ts-expect-error - Argument of type 'JQueryRequestInit | FetchRequestInit' is not assignable to parameter of type 'AJAXOptions | undefined
      super.ajaxOptions(url, type, options),
    );
  }

  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  buildURL(...args: Parameters<RESTAdapter['buildURL']>) {
    let url = super.buildURL(...args);

    if (url.charAt(url.length - 1) !== '/') {
      url += '/';
    }

    return url;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getQueryParameterByName(name: string) {
    const newName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${newName}=([^&#]*)`);
    const results = regex.exec(window.location.search);

    if (results === null || results?.[1] === undefined) {
      return '';
    }

    return decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  pathForType(modelName: string) {
    return pluralize(modelName);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateRecord(store: Store, schema: ModelSchema, snapshot: Snapshot) {
    const data = {};

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    const serializer = store.serializerFor(schema.modelName);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call,  @typescript-eslint/no-unsafe-member-access
    serializer.serializeIntoHash(data, schema, snapshot, {
      excludeUnchangedAttributes: true,
    });

    const url = this.buildURL(
      snapshot.modelName,
      snapshot.id,
      snapshot,
      // @ts-expect-error: Expected 3 arguments, but got 4.
      'updateRecord',
    );

    return this.ajax(url, 'PATCH', { data });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForQuery(query: { subscriptionId?: string }) {
    const { subscriptionId } = query;
    delete query.subscriptionId; // subscriptionId shouldn't be sent as a query param
    return `${this.host}/${this.namespace}/paritystrategy/hotels/${subscriptionId}/issues/`;
  }

  urlForUpdateRecord(
    id: string,
    modelName: string,
    snapshot: Snapshot,
  ): string {
    // @ts-expect-error: Argument of type 'string' is not assignable to parameter of type 'never'.
    const subscriptionId = snapshot.attr('subscriptionId');
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return `${this.host}/${this.namespace}/paritystrategy/hotels/${subscriptionId}/issues/${id}/`;
  }
}
